import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Card, CardContent, IconButton, Typography, Button, Avatar, Divider, CircularProgress, Grid, CardMedia, CardHeader, Tabs, Tab, Radio } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import EmailIcon from '@mui/icons-material/Email';
import PropTypes from 'prop-types';
import PersonIcon from '@mui/icons-material/Person';
import DescriptionIcon from '@mui/icons-material/Description';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SchoolIcon from '@mui/icons-material/School';
import WorkIcon from '@mui/icons-material/Work';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NoDataImg from '../assets/nodata.png';
import { formatDate } from '../helpers/handleDate';
import { empTypeHelper } from '../helpers/empTypeHelper';


import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';

import Experiance from './user_information/Experiance';
import Documents from './user_information/Documents';
import Bankdetailss from './user_information/Bankdetails';
import Personal from './user_information/Personal';
import Education from './user_information/Education';
import Basicdetails from './user_information/BasicDetails';
import { makeApiRequest } from '../utils/api';
import { useNavigate } from 'react-router-dom';
import OverflowTooltip from '../helpers/OverflowTooltip';
import InfoIcon from '@mui/icons-material/Info';
import { getLocation } from '../helpers/commonHelper';

ChartJS.register(ArcElement, Tooltip, Legend);

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
function AssessmentTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`assessment-tabpanel-${index}`}
      aria-labelledby={`assessment-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

AssessmentTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function assessmentTabProps(index) {
  return {
    id: `assessment-tab-${index}`,
    'aria-controls': `assessment-tabpanel-${index}`,
  };
}


const Profile = () => {
  const location = useLocation();
  const { userid } = location.state || {};
  const [employeeData, setEmployeeData] = useState({});
  const [error, setError] = useState(null);
  const [value, setValue] = useState(0);
  const [assessmentTabValue, setAssessmentTabValue] = useState(0);
  const [selectedAssessment, setSelectedAssessment] = useState(null);
  const [realAssessments, setRealAssessments] = useState([]);
  const [completedAssessments, setCompletedAssessments] = useState([]);
  const [pendingAssessments, setPendingAssessments] = useState([]);

  const navigate = useNavigate();
  const control = localStorage.getItem('control');
  const mockAssessments = {
    completed: completedAssessments,
    pending: pendingAssessments
  };


  const getCourse = async (id) => {
    try {
      const response = await makeApiRequest('post', 'api/course/list/id', {
        token: localStorage.getItem('authToken'),
        id: id
      });
      if (response?.status === 'success') {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to fetch employee details');
      }
    } catch (err) {
      console.error('Error fetching employee data:', err);
      setError(err.message || 'Error occurred while fetching employee data');
    }
  }

  const getBatch = async (id) => {
    try {
      const response = await makeApiRequest('post', 'api/listBatch/id', {
        token: localStorage.getItem('authToken'),
        id: id
      });
      if (response?.status === 'success') {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to fetch employee details');
      }
    } catch (err) {
      console.error('Error fetching employee data:', err);
      setError(err.message || 'Error occurred while fetching employee data');
    }
  }

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const storedUserId = localStorage.getItem('userid');
        const userId = userid || storedUserId;

        if (!userId) {
          throw new Error('User ID is missing');
        }

        const requestData = {
          token: token,
          data: { userid: userId },
        };


        const response = await makeApiRequest('post', '/api/employee/profile', requestData, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
        });

        if (response?.status === 'success') {
          setEmployeeData(response.data.data);
          setRealAssessments(response.data.data.assessment);
          const assessmentsFromAPI = response.data.data.assessment || [];
          const completed = [];
          const pending = [];

          assessmentsFromAPI.forEach((a, index) => {
            const scoreData = {
              written: { value: a.written_mark || 0, total: 3 },
              viva: { value: a.viva_mark || 0, total: 3 },
              project: { value: a.project_presentation || 0, total: 4 },
              total: {
                value: a.total || 0, total: 10
              }
            };

            const formatted = {
              id: index,
              title: a.genericName,
              subtitle: a.specificName,
              scores: scoreData
            };

            if (a.status?.toLowerCase() === 'completed') completed.push(formatted);
            else pending.push(formatted);
          });

          setCompletedAssessments(completed);
          setPendingAssessments(pending);

        } else {
          throw new Error(response.data.message || 'Failed to fetch employee details');
        }
      } catch (err) {
        console.error('Error fetching employee data:', err);
        setError(err.message || 'Error occurred while fetching employee data');
      }
    };

    fetchEmployeeData();
  }, [userid]);


  const handleChange = (event, newValue) => {
    setValue(newValue);
  }

  useEffect(() => {
    // Select the first completed assessment on initial load
    if (mockAssessments.completed.length > 0 && assessmentTabValue === 0) {
      setSelectedAssessment(mockAssessments.completed[0]);
    } else if (mockAssessments.pending.length > 0 && assessmentTabValue === 1) {
      setSelectedAssessment(mockAssessments.pending[0]);
    }
  }, []);

  const handleAssessmentTabChange = (event, newValue) => {
    setAssessmentTabValue(newValue);
    setSelectedAssessment(null);

    if (newValue === 0 && mockAssessments.completed.length > 0) {
      setSelectedAssessment(mockAssessments.completed[0]);
    } else if (newValue === 1 && mockAssessments.pending.length > 0) {
      setSelectedAssessment(mockAssessments.pending[0]);
    }
  };

  const handleAssessmentSelect = (assessment) => {
    setSelectedAssessment(assessment);
  }

  const handleEdit = (e) => {
    if (e) e.preventDefault();
    const transformedData = {
      basic: {
        ...employeeData.basic,
        username: employeeData.basic?.userid || '',
        name: employeeData.name?.split(' ')[0] || '',
        name2: employeeData.name?.split(' ').slice(1).join(' ') || '',
        phoneno: employeeData.mobile_num || '',
        addr: employeeData.personal?.addr || '',
        paddr: employeeData.personal?.per_addr || '',
        reportto: employeeData.basic?.reportid || '',
        location: employeeData.basic?.location || '',
        batch_id: employeeData.basic?.batch_id || '',
        course_id: employeeData.basic?.course_id || '',
      },
      personal: {
        ...employeeData.personal,
        official_email: employeeData.email || '',
        dob_in_cert: employeeData.personal?.dob_in_cert || '',
        dob_org: employeeData.personal?.dob_org || '',
        marital_status: employeeData.personal?.marital_status || '',
        father_spouse_name: employeeData.personal?.father_spouse_name || '',
        personal_email: employeeData.personal?.personal_email || '',
        alternate_contact_no: employeeData.personal?.alternate_contact_no || '',
        nationality: employeeData.personal?.nationality || '',
        bg: employeeData.personal?.bg || '',
        image: employeeData.personal?.image || '',
      },
      documents: employeeData.documents || {},
      education: {
        sslc: employeeData.education?.sslc || {},
        hlc: employeeData.education?.hlc || {},
        diploma: employeeData.education?.diploma || {},
        bachelor: employeeData.education?.bachelor || {},
        master: employeeData.education?.master || {}
      },
      experience: employeeData.experience || {},
      bank_details: employeeData.bank_details || {},
      emergency_contact: employeeData.emergency_contact || {}
    };

    navigate('/add-team-member', { state: { editMode: true, formData: transformedData } });
  };

  if (error) {
    console.log(error);
    return <div>Error: {error}</div>;
  }

  if (!employeeData) {
    console.log('no data');
    return (
      <div>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="400px"
        >
          <CircularProgress
            size={40}
            thickness={4}
            sx={{
              color: '#481E82',
            }}
          />
        </Box>
      </div>
    );
  }

  const AssessmentDonutChartWithLabel = ({ value, total, label, completed }) => {
    const percentage = (value / total) * 100;
    const remaining = total - value;
    const greenColor = `#4caf50`;
    const redColor = '#f44336';
    const chartColor = completed ? [greenColor, redColor] : [redColor, redColor];
    const displayColor = completed ? greenColor : redColor;




    const data = {
      datasets: [{
        data: [value, remaining],
        backgroundColor: chartColor,
        borderWidth: 0,
        cutout: '70%',
      }]
    };

    const options = {
      responsive: false,
      plugins: {
        legend: { display: false },
        tooltip: { enabled: false },
      }
    };


    return (
      <Box sx={{
        width: 120,
        textAlign: 'center',
        padding: 1
      }}>
        <Box sx={{ position: 'relative', width: 100, height: 100, margin: '0 auto' }}>
          <Doughnut data={data} options={options} width={100} height={100} />
          <Box sx={{
            position: 'absolute',
            top: 0, left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <Typography variant="caption" color="textSecondary">
              Total
            </Typography>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, fontSize: '1rem' }}>
              <span style={{ color: '#1976D2' }}>{value}</span>
              <span style={{ color: '#481E82' }}>/{total}</span>
            </Typography>
          </Box>
        </Box>
        <Typography
          variant="body2"
          sx={{ mt: 1, color: '#1976D2', fontWeight: 500, fontSize: '15px' }}
        >
          {label}
        </Typography>
      </Box>
    );
  };

  return (
    <Box sx={{ padding: { xs: 2, sm: 3, md: 4 }, backgroundColor: '#f1f4f9' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'center',
          alignItems: 'flex-start',
          gap: { xs: 2, sm: 3, lg: 4 },
          flexWrap: 'wrap',
        }}
      >
        <Grid container spacing={4}>
          {/* First Card - Profile Card */}
          <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ borderRadius: '5px', display: 'flex', flexDirection: 'column', height: '100%', position: "relative" }}>
              <CardHeader
                sx={{
                  backgroundColor: "#30459C",
                  height: "140px",
                  position: "relative",
                }}
              />
              <Box sx={{ position: "relative" }}>
                <CardMedia>
                  <Avatar
                    sx={{
                      width: 180,
                      height: 180,
                      position: "absolute",
                      top: "50%",
                      right: "50%",
                      transform: "translate(50%, -50%)",
                    }}
                    alt="User Profile"
                    src={`${process.env.REACT_APP_API_URL}/documents/${employeeData?.personal?.image}`}
                  // src={`http://16.171.0.8/documents/${employeeData?.personal?.image}`}
                  // src={`http://127.0.0.1:8000/documents/${employeeData?.personal?.image}`}

                  />
                </CardMedia>
              </Box>
              {(control == 1 || control == 4) &&
                <Box sx={{ position: "absolute", top: 8, right: 0, zIndex: 1000 }}>
                  <Button onClick={handleEdit}>
                    <EditIcon style={{ color: "white" }} /></Button>
                </Box>
              }
              <CardContent sx={{ flexGrow: 1, mt: 9, p: 3 }}>
                <Typography variant="h6" sx={{ fontSize: '24px', mb: 1 }}>
                  {employeeData?.name || 'No Name Available'}
                </Typography>
                <Typography variant="body1" color="textSecondary" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <PhoneIphoneIcon style={{ marginRight: '10px' }} />
                  <span style={{ color: '#29BF12', fontSize: '16px' }}>{employeeData?.mobile_num || 'No Mobile Number'}</span>
                </Typography>
                <Typography variant="body1" color="textSecondary" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <LocationOnIcon style={{ marginRight: '10px' }} />
                  <span style={{ color: '#1976D2', fontSize: '15px' }}>{getLocation(employeeData?.basic?.location) || 'Unknown Location'}</span>
                </Typography>
                <Typography variant="body1" color="textSecondary" sx={{ display: 'flex', alignItems: 'center' }}>
                  <EmailIcon style={{ marginRight: '10px' }} />
                  <OverflowTooltip><span style={{ color: '#1976D2', fontSize: '15px' }}>{employeeData?.email || 'No Email Available'}</span></OverflowTooltip>
                </Typography >
              </CardContent>
            </Card>
          </Grid>

          {/* Assessment Card */}
          {employeeData.basic?.control === "3" && (
            <Grid item xs={12} sm={6} md={8}>
              <Card sx={{ borderRadius: '5px', display: 'flex', flexDirection: 'column', height: '100%' }}>
                <CardHeader
                  title="Assessments"
                  sx={{
                    color: "#481E82",
                    p: 3,
                    "& .MuiCardHeader-title": { fontSize: { md: "24px", lg: "34px" } },
                  }}
                />
                <Divider sx={{ mx: 2, mt: -3 }} />
                <CardContent sx={{ flexGrow: 1, p: 2, display: 'flex' }}>
                  <Box sx={{ width: '35%', pr: 2 }}>
                    <Box sx={{}}>
                      <Tabs
                        value={assessmentTabValue}
                        onChange={handleAssessmentTabChange}
                        aria-label="assessment tabs"
                        sx={{ '& .MuiTab-root': { minHeight: '48px' } }}
                      >
                        <Tab
                          icon={<CheckCircleOutlineIcon sx={{ color: '#4caf50', mr: 1, mt: 1 }} />}
                          label={`COMPLETED (${mockAssessments.completed.length})`}
                          {...assessmentTabProps(0)}
                          sx={{
                            fontSize: '12.5px',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        />
                        <Tab
                          icon={<PendingActionsIcon sx={{ color: '#f44336', mr: 1 }} />}
                          label={`PENDING (${mockAssessments.pending.length})`}
                          {...assessmentTabProps(1)}
                          sx={{
                            fontSize: '12.5px',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        />
                      </Tabs>
                    </Box>

                    {/* Completed Assessments List */}
                    <AssessmentTabPanel value={assessmentTabValue} index={0}>
                      {mockAssessments.completed.length > 0 ? (
                        <Box>
                          {mockAssessments.completed.map((assessment) => (
                            <Card
                              key={assessment.id}
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                mb: 1.5,
                                p: 1,
                                cursor: 'pointer',
                                borderBottom: '1px solid #e0e0e0',
                                backgroundColor: selectedAssessment?.id === assessment.id ? '#E3F2FD' : '#F1F4F9', // Highlight selected card
                                border: selectedAssessment?.id === assessment.id ? '1px solid #0091EA' : '4px solid transparent', // Blue border for selected
                                '&:hover': { backgroundColor: '#CAF0F817', cursor: 'pointer' },
                              }}
                              onClick={() => handleAssessmentSelect(assessment)}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Radio
                                  checked={selectedAssessment?.id === assessment.id}
                                  color="primary"
                                  size="medium"
                                  sx={{ mr: 1 }}
                                />
                                <Box>
                                  <Typography variant="subtitle1">{assessment.title}</Typography>
                                  <Typography variant="body2" color="textSecondary">{assessment.subtitle}</Typography>
                                </Box>
                              </Box>
                              {selectedAssessment?.id === assessment.id ? (
                                <ArrowForwardIosIcon fontSize="small" color="action" />
                              ) : (
                                <ExpandMoreIcon fontSize="large" color="action" />
                              )}
                            </Card>
                          ))}
                        </Box>
                      ) : (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px', width: '100%' }}>
                          <img src={NoDataImg} alt="No data" style={{ maxWidth: '100%', height: 'auto' }} />
                        </Box>
                      )}
                    </AssessmentTabPanel>

                    {/* Pending Assessments List */}
                    <AssessmentTabPanel value={assessmentTabValue} index={1}>
                      {mockAssessments.pending.length > 0 ? (
                        <Box>
                          {mockAssessments.pending.map((assessment) => (
                            <Card
                              key={assessment.id}
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                mb: 1.5,
                                p: 1,
                                cursor: 'pointer',
                                borderBottom: '1px solid #e0e0e0',
                                backgroundColor: selectedAssessment?.id === assessment.id ? '#E3F2FD' : '#F1F4F9', // Highlight selected card
                                border: selectedAssessment?.id === assessment.id ? '1px solid #0091EA' : '4px solid transparent', // Blue border for selected
                                '&:hover': { backgroundColor: '#CAF0F817', cursor: 'pointer' },
                              }}
                              onClick={() => handleAssessmentSelect(assessment)}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Radio
                                  checked={selectedAssessment?.id === assessment.id}
                                  color="primary"
                                  size="medium"
                                  sx={{ mr: 1 }}
                                />
                                <Box>
                                  <Typography variant="subtitle1">{assessment.title}</Typography>
                                  <Typography variant="body2" color="textSecondary">{assessment.subtitle}</Typography>
                                </Box>
                              </Box>
                              {selectedAssessment?.id === assessment.id ? (
                                <ArrowForwardIosIcon fontSize="small" color="action" />
                              ) : (
                                <ExpandMoreIcon fontSize="large" color="action" />
                              )}
                            </Card>
                          ))}
                        </Box>
                      ) : (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px', width: '100%' }}>
                          <img src={NoDataImg} alt="No data" style={{ maxWidth: '100%', height: 'auto' }} />
                        </Box>
                      )}
                    </AssessmentTabPanel>
                  </Box>

                  {/* Selected Assessment Details */}
                  {selectedAssessment && (
                    <Card sx={{ width: '65%', pl: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', border: assessmentTabValue === 0 ? '1px solid #25A244' : '1px solid #D32F2F', backgroundColor: assessmentTabValue === 0 ? '#F0FFF1' : '#FFCCD561' }}>
                      <Typography variant="h6" sx={{ mb: 1, color: 'green', fontWeight: 'bold', fontSize: '24px' }}>{selectedAssessment.title}</Typography>
                      <Typography variant="subtitle2" color="textSecondary" sx={{ mb: 2, textAlign: 'center', fontSize: '15px' }}>
                        {selectedAssessment.subtitle}
                      </Typography>
                      <Grid container spacing={2} justifyContent="center">
                        <Grid item xs={6} sm={3} sx={{ display: 'flex', justifyContent: 'center' }}>
                          <AssessmentDonutChartWithLabel
                            value={selectedAssessment.scores.written.value}
                            total={selectedAssessment.scores.written.total}
                            label="Written"
                            completed={assessmentTabValue === 0}

                          />
                        </Grid>
                        <Grid item xs={6} sm={3} sx={{ display: 'flex', justifyContent: 'center' }}>
                          <AssessmentDonutChartWithLabel
                            value={selectedAssessment.scores.viva.value}
                            total={selectedAssessment.scores.viva.total}
                            label="Viva"
                            completed={assessmentTabValue === 0}
                          />
                        </Grid>
                        <Grid item xs={6} sm={3} sx={{ display: 'flex', justifyContent: 'center' }}>
                          <AssessmentDonutChartWithLabel
                            value={selectedAssessment.scores.project.value}
                            total={selectedAssessment.scores.project.total}
                            label="Project Presentation"
                            completed={assessmentTabValue === 0}
                          />
                        </Grid>
                        <Grid item xs={6} sm={3} sx={{ display: 'flex', justifyContent: 'center' }}>
                          <AssessmentDonutChartWithLabel
                            value={selectedAssessment.scores.total.value}
                            total={selectedAssessment.scores.total.total}
                            label="Total"
                            completed={assessmentTabValue === 0}
                          />
                        </Grid>
                      </Grid>
                    </Card>
                  )}
                </CardContent>
              </Card>
            </Grid>
          )}
          {employeeData.basic?.control === "2" && (
            <>
              <Grid item xs={12} sm={6} md={4}>
                <Card sx={{ borderRadius: '8px', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <CardHeader
                    title="Basic Details"
                    sx={{
                      color: "#481E82", p: 3,
                      "& .MuiCardHeader-title": { fontSize: { md: "24px", lg: "34px" } },
                    }}
                  />
                  <Divider sx={{ mx: 3 }} />
                  <CardContent sx={{ flexGrow: 1, p: 4 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ width: '100%' }}>
                          <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                            Employee ID
                          </Typography>
                          <Typography variant="body2" sx={{ color: '#000001DE', fontSize: { md: '16px', lg: '18px' } }}>
                            {employeeData?.basic?.userid || 'N/A'}
                          </Typography>
                        </Box>                   </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box alignItems="flex-start" sx={{ width: '100%' }}>
                          <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px', marginRight: '27px' }}>
                            Reporting To
                          </Typography>
                          <Typography variant="body2" sx={{ color: '#000001DE', fontSize: { md: '16px', lg: '18px' } }}>
                            {employeeData?.basic?.reportto || 'N/A'}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ width: '100%' }}>
                          <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                            Employee type
                          </Typography>
                          <Typography variant="body2" sx={{ color: '#000001DE', fontSize: { md: '16px', lg: '18px' } }}>
                            {employeeData?.basic?.emp_type ? empTypeHelper(employeeData.basic.emp_type) : 'N/A'}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box alignItems="flex-start" sx={{ width: '100%' }}>
                          <Typography variant="body1" sx={{ color: '#9E9E9E', fontSize: '14px' }}>
                            Organization DOJ
                          </Typography>
                          <Typography variant="body2" sx={{ color: '#000001DE', fontSize: { md: '16px', lg: '18px' } }}>
                            {employeeData?.basic?.org_doj ? formatDate(employeeData.basic.org_doj) : 'N/A'}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ width: '100%' }}>
                          <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                            Qural Experience
                          </Typography>
                          <Typography variant="body2" sx={{ color: '#000001DE', fontSize: { md: '16px', lg: '18px' } }}>
                            {employeeData?.basic?.conserv_exp || 'N/A'}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ width: '100%' }}>
                          <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                            Employment Status
                          </Typography>
                          <Typography variant="body2" sx={{ color: '#000001DE', fontSize: { md: '16px', lg: '18px' } }}>
                            {employeeData?.basic?.estatus || 'N/A'}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ width: '100%' }}>
                          <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                            Course
                          </Typography>
                          <Typography variant="body2" sx={{ color: '#000001DE', fontSize: { md: '16px', lg: '18px' } }}>
                            {employeeData?.basic?.course || 'N/A'}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ width: '100%' }}>
                          <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                            Batch
                          </Typography>
                          <Typography variant="body2" sx={{ color: '#000001DE', fontSize: { md: '16px', lg: '18px' } }}>
                            {employeeData?.basic?.batch || 'N/A'}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <Card sx={{ borderRadius: '8px', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <CardHeader
                    title="Address"
                    sx={{
                      color: "#481E82", p: 3,
                      "& .MuiCardHeader-title": { fontSize: { md: "24px", lg: "34px" } },
                    }}
                  />
                  <Divider sx={{ mx: 3 }} />
                  <CardContent sx={{ flexGrow: 1, p: 3 }}>
                    <Grid container>
                      <Grid item xs={12}>
                        <Box
                          sx={{
                            border: '1px solid #ccc',
                            borderRadius: '24px',
                            padding: 2,
                            height: '100px',
                            marginBottom: '25px',
                          }}
                        >
                          <Typography variant="body1" style={{ fontSize: '14px', color: '#9E9E9E' }}>
                            Residential Address
                          </Typography>
                          <Box sx={{ fontSize: { xs: "16px", sm: '16px' }, color: 'black', wordBreak: 'break-word' }}>
                            {employeeData?.personal?.addr || 'N/A'}
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <Box
                          sx={{
                            border: '1px solid #ccc',
                            borderRadius: '24px',
                            padding: 2,
                            height: '100px',
                          }}
                        >
                          <Typography variant="body1" style={{ fontSize: '14px', color: '#9E9E9E' }}>
                            Permanent Address
                          </Typography>
                          <Box sx={{ fontSize: { xs: "16px", sm: '16px' }, color: 'black', wordBreak: 'break-word' }}>
                            {employeeData?.personal?.per_addr || 'N/A'}
                          </Box>
                        </Box>
                      </Grid>

                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </>
          )
          }
        </Grid>
      </Box>

      {/* Details Card with Tabs */}
      <Card sx={{ marginTop: '47px' }}>
        <Box sx={{ width: '100%' }}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              backgroundColor: '#caf0f8',
              padding: '5px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            {/* Tabs */}
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab
                label={
                  <Box display="flex" alignItems="center">
                    <PersonIcon sx={{ marginRight: 1 }} /> PERSONAL
                  </Box>
                }
                {...a11yProps(0)}
              />
              <Tab
                label={
                  <Box display="flex" alignItems="center">
                    <DescriptionIcon sx={{ marginRight: 1 }} /> DOCUMENTS
                  </Box>
                }
                {...a11yProps(1)}
              />
              <Tab
                label={
                  <Box display="flex" alignItems="center">
                    <AccountBalanceIcon sx={{ marginRight: 1 }} /> BANK DETAILS
                  </Box>
                }
                {...a11yProps(2)}
              />
              <Tab
                label={
                  <Box display="flex" alignItems="center">
                    <SchoolIcon sx={{ marginRight: 1 }} /> EDUCATION
                  </Box>
                }
                {...a11yProps(3)}
              />
              <Tab
                label={
                  <Box display="flex" alignItems="center">
                    <WorkIcon sx={{ marginRight: 1 }} /> EXPERIENCE
                  </Box>
                }
                {...a11yProps(4)}
              />


              {employeeData.basic?.control === "3" && (
                <Tab
                  label={
                    <Box display="flex" alignItems="center">
                      <InfoIcon sx={{ marginRight: 1 }} /> Basic Details
                    </Box>
                  }
                  {...a11yProps(5)}
                />
              )}
            </Tabs>

          </Box>
          <CustomTabPanel value={value} index={0}>
            <Personal employeeData={employeeData} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <Documents employeeData={employeeData} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <Bankdetailss employeeData={employeeData} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <Education employeeData={employeeData} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={4}>
            <Experiance employeeData={employeeData} />
          </CustomTabPanel>

          {employeeData.basic?.control === "3" && (
            <CustomTabPanel value={value} index={5}>
              <Basicdetails employeeData={employeeData} />
            </CustomTabPanel>
          )}
        </Box>
      </Card>
    </Box>
  );
}

export default Profile;